import React, { useState } from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import Seo from '../components/Seo';
import { mediaBreakpointDown, mediaBreakpointUp } from '../utils/styling';
import background from '../images/banner.svg';
import SolveIssueBanner from '../components/NewSolveIssueBanner';
import RecentPosts from '../components/RecentPosts';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Link from '../components/Link';
import CategoriesWidget from '../components/CategoriesWidget';
import InfiniteScroll from 'react-infinite-scroll-component';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import { symbolParse } from "../utils/symbolparse";
import { useTracking } from "../components/Tracking/index";
import { Script } from 'gatsby';

const HeroBanner = styled.div`
	width: 100%;
	margin-bottom: 118px;

	${mediaBreakpointDown('sm')} {
		margin-bottom: 50px;
	}
`;
const HeroImage = styled.div`
	min-height: 570px;
	background-image: url('${background}');
	background-size: cover;
	background-repeat: no-repeat;
	background-position: bottom center;
	display: flex;
	align-items: center;
	background-color: #fff;

	width: 100%;
	padding: 30px 20px;

	${mediaBreakpointDown('md')} {
		min-height: 350px;
	}
	${mediaBreakpointDown('sm')} {
		min-height: 250px;
	}
`;

const HeroContent = styled.div`
	max-width: 1166px;
	margin: 0 auto;
	width: 100%;
`;

const HeroTitle = styled.h1`
	letter-spacing: -0.043em;
	line-height: 1.1em;
	color: #002047;
	margin: 0;
	font-size: 60px;
	${mediaBreakpointUp('xl')} {
		font-size: 64px;
	}
	${mediaBreakpointDown('md')} {
		font-size: 50px;
	}
	${mediaBreakpointDown('sm')} {
		font-size: 35px;
	}
`;

const CategoriesSection = styled.section`
	max-width: 1170px;
	padding: 0 20px;
	margin: 0 auto 100px auto;
`;
const CategoryTitle = styled.h2`
	font-size: 36px;
	margin: 0 0 50px 0;
	text-align: center;
	color: #002047;
`;
const CategoryContainer = styled.div`
	display: flex;
	align-items: flex-start;
	${mediaBreakpointDown('md')} {
		flex-direction: column;
	}
`;
const CategoryContent = styled.div`
	flex: 1;
	display: flex;
	flex-wrap: wrap;
	margin: 0 -20px -20px -20px;
	${mediaBreakpointDown('sm')} {
		flex-direction: column;
	}
`;
const CategoryColumn = styled.div`
	flex-basis: 50%;
	padding: 0 20px 20px 20px;
`;
const CategoryColumnTitle = styled.h3`
	padding-right: 20px;
	font-size: 20px;
	line-height: 24px;
	letter-spacing: 0.16px;
	> span {
		font-weight: 600;
		font-size: 20px;
		color: #617792;
	}

	> a {
		transition: all 0.3s ease-in-out 0s;
		color: #002047;
		cursor: pointer;
		:hover {
			color: #e01efe;
		}
	}
`;
const CategoryPostList = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;
`;
const CategoryPostListItem = styled.li`
	position: relative;
	margin-bottom: 23px;
	padding-left: 25px;

	&:nth-child(5) {
		margin-bottom: 5px;
	}

	:before {
		content: '';
		display: block;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background-color: #ced8e1;
		position: absolute;
		left: 0;
		top: 50%;
		-ms-transform: translate(0, -50%);
		transform: translate(0, -50%);
	}

	> a {
		font-weight: 500;
		color: #617792;
		font-size: 16px;
		transition: all 0.3s ease-in-out 0s;
		cursor: pointer;
		:hover {
			color: #e01efe;
		}
	}
`;
const CategorySidebar = styled.div`
	min-width: 370px;
	max-width: 370px;
	margin-left: 100px;
	width: 100%;
	${mediaBreakpointDown('md')} {
		min-width: 0;
		margin-left: 0;
		width: 100%;
		margin-top: 20px;
	}
`;

const SolveIssueContainer = styled.div`
	margin-bottom: 40px;
	${mediaBreakpointDown('md')} {
		width: 370px;
	}
	${mediaBreakpointDown('xs')} {
		width: 100%;
	}
`;
const RecentPostContainer = styled.div``;
const CallToActionContainer = styled.section`
	margin-bottom: 130px;
`;
const CallToActionContent = styled.div`
	padding: 90px 20px 0;
	max-width: 1170px;
	border-top: 1px solid #eef2f5;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`;
const CallToActionH2 = styled.h2`
	margin: 0 0 25px 0;
	text-align: center;
	font-size: 47px;
	${mediaBreakpointDown('sm')} {
		font-size: 35px;
	}
`;
const CallToActionP = styled.p`
	font-weight: 500;
	max-width: 382px;
	text-align: center;
	// color: #8e9cab;
	color: #8e9cabf2;
	margin: 0 auto 30px;
	font-size: 18px;
	line-height: 1.4em;
`;
const CallToActionButton = styled.button`
	border-radius: 30px;
	max-width: 190px;
	background-color: #e01efe;
	// color: #fff;
	color: #fffffff6;
	width: 100%;
	text-align: center;
	padding: 17px 40px;
	font-weight: 600;
	transition: all 0.3s ease-in-out 0s;
	border: 1px solid #e01efe;

	:hover {
		color: #e01efe;
		background-color: #fff;
	}
`;

const SeeAllContainer = styled.div`
	width: 100%;
	padding-top: 5px;
`;

const SeeAll = styled.span`
	// color: #e01efe;
	color: #e01efee8;
	border-bottom: 2px solid;
	line-height: 16px;
	margin-left: 25px;

	:hover {
		color: #b919d1;
	}
`;

export default function IndexPage({
	data: {
		cms: { categories, posts },
	},
}) {
	let filteredCategories = [];
	categories.edges.forEach(({ node }) => {
		if (node.name !== 'Uncategorized') {
			filteredCategories.push(node);
		}
	});


	filteredCategories.sort((a, b) => {
		var nameA = a.name.toUpperCase(); // ignore upper and lowercase
		var nameB = b.name.toUpperCase(); // ignore upper and lowercase
		if (nameA < nameB) {
			return -1;
		}
		if (nameA > nameB) {
			return 1;
		}

		// names must be equal
		return 0;
	});

	const categoriesWidget = { edges: categories.edges.slice(0, 12) };

	const [displayBg, setDisplayBg] = useState(false);

	const Tracking = useTracking();

	return (
		<div>
			<Script id="test-script">{`
				var vglnk = {key: 'API_KEY'};
				(function(d, t) {
					var s = d.createElement(t);
						s.type = 'text/javascript';
						s.async = true;
						s.src = '//cdn.viglink.com/api/vglnk.js';
					var r = d.getElementsByTagName(t)[0];
						r.parentNode.insertBefore(s, r);
				}(document, 'script'));

			`}</Script>
			<Header />
			<Seo
				title={
					"DoNotPay is your AI Consumer Champion. We use artificial intelligence to help you fight big corporations, protect your privacy, find hidden money, and beat bureaucracy."
				}
				ogURL={'https://donotpay.com/learn/'}
				ogType={'website'}
				ogTitle={
					"DoNotPay is your AI Consumer Champion. We use artificial intelligence to help you fight big corporations, protect your privacy, find hidden money, and beat bureaucracy."
				}
				ogSiteName={'DoNotPay'}
				ogDescription={
					"DoNotPay is your AI Consumer Champion. We use artificial intelligence to help you fight big corporations, protect your privacy, find hidden money, and beat bureaucracy."
				}
				metaRobotsNofollow={'follow'}
				metaRobotsNoindex={'index'}
				slug={'main'}
				canonical
			/>
			<div>
				<HeroBanner>
					<HeroImage>
						<HeroContent>
							<HeroTitle>DoNotPay Community</HeroTitle>
						</HeroContent>
					</HeroImage>
				</HeroBanner>
				<CategoriesSection>
					<CategoryTitle>Article Categories</CategoryTitle>
					<CategoryContainer>
						<InfiniteScroll
							dataLength={filteredCategories.length} //This is important field to render the next data
							next={() => {
								setDisplayBg(true);
							}}
							hasMore={!displayBg}
							loader={<h4>Loading...</h4>}
							style={{ overflow: 'hidden' }}
						>
							<CategoryContent>
								{filteredCategories.map((edge, index) => {
									let show = false;
									const posts = edge.wpTopPostsConnection;

									if (posts && posts.edges && posts.edges.length > 0) {
										show = true;
									}
									if (!show) {
										return
									}
									return (
										<CategoryColumn key={edge.id}>
											<CategoryColumnTitle>
												<Link noPrefetch to={`/${edge.slug}/`}>
													{symbolParse(edge.name)}
												</Link>{' '}
											</CategoryColumnTitle>
											<CategoryPostList>
												{show &&
													posts.edges.map(({ node: post }, index) => {
														return (
															<CategoryPostListItem key={post.id}>
																<Link noPrefetch to={`/${post.slug}/`}>
																	{symbolParse(post.title)}
																</Link>
															</CategoryPostListItem>
														);
													})}
												{show && (
													<SeeAllContainer>
														<Link noPrefetch to={`/${edge.slug}/`}>
															<SeeAll>See All →</SeeAll>
														</Link>{' '}
													</SeeAllContainer>
												)}
											</CategoryPostList>
										</CategoryColumn>
									);
								})}
							</CategoryContent>
						</InfiniteScroll>
						<CategorySidebar>
							<SolveIssueContainer>
								<SolveIssueBanner url="https://donotpay.com/web" />
							</SolveIssueContainer>
							<RecentPostContainer>
								<RecentPosts posts={posts} />
							</RecentPostContainer>
							<RecentPostContainer>
								<CategoriesWidget categories={categoriesWidget} />
							</RecentPostContainer>
						</CategorySidebar>
					</CategoryContainer>
				</CategoriesSection>
				<CallToActionContainer>
					<CallToActionContent>
						<CallToActionH2>Let DoNotPay solve your problem for you</CallToActionH2>
						<CallToActionP>
							DoNotPay is your AI Consumer Champion. We use artificial intelligence to help you fight big corporations, protect your privacy, find hidden money, and beat bureaucracy.
						</CallToActionP>
						{/* 	<Link to="https://donotpay.com/web"> */}
						<CallToActionButton
							onClick={() => {
								trackCustomEvent({
									category: 'Learning Center CTA Click',
									action: 'click',
									label: 'Get Started, Main Page Lower CTA',
								});
								trackCustomEvent({
									category: 'Entire page tracker',
									action: 'click',
									label: 'Get Started, Main Page Lower CTA',
								});
								document.location = 'https://donotpay.com/web';
							}}
							className="smp-footer-home"
							aria-label="Get Started"
						>
							Get Started
						</CallToActionButton>
						{/* 	</Link> */}
					</CallToActionContent>
				</CallToActionContainer>
			</div>
			<Footer />
		</div>
	);
}

export const pageQuery = graphql`
	query AllCategories {
		cms {
			# selecting the current post by id
			categories: wpCategoriesConnection(first: 100000, sortByNameAsc: true, isLearnWebsite: true) {
				edges {
					node {
						id
						name
						slug

						wpTopPostsConnection: wpPostsConnection(first: 5, topPost: true) {
							edges {
								node {
									title
									slug
								}
							}
						}
					}
				}
			}
			posts: wpPostsConnection(first: 5, sortByPublishedDateDesc: true, isLearnWebsite: true) {
				edges {
					node {
						id
						slug
						title
					}
				}
			}
		}
	}
`;